<template>
  <div class="h5-shipping-method">
    <p class="h5-shipping-method__title">
      Shipping Methods
    </p>
    <p class="h5-shipping-method__subTitle">
      Your order shipping & delivery with
      <Icon
        name="bestdealer-logo"
        class="h5-shipping-method__logo"
      />
    </p>
    <ShippingSelect class="h5-shipping-method__select" />
    <div
      class="h5-shipping-method__location"
      v-if="addressStore.cacheAddress"
    >
      <img
        class="h5-shipping-method__country"
        :src="addressStore.cacheAddress.searchImg"
      >
      <p class="h5-shipping-method__address">
        {{ addressStore.cacheAddress.city }}
      </p>
      <p
        class="h5-shipping-method__change"
        @click="showAddressDialog = true"
      >
        Change
      </p>
    </div>
    <div
      class="h5-shipping-method__location"
      v-else
    >
      <img
        class="h5-shipping-method__country"
        :src="countryUrl"
      >
      <p class="h5-shipping-method__address">
        Ship to My Address
      </p>
      <p
        class="h5-shipping-method__add"
        @click="showAddressDialog = true"
      >
        Add new address
      </p>
    </div>
    <div class="h5-shipping-method__delivery">
      Estimated Delivery Time:
      <template v-if="addressStore.cacheAddress">
        <span>{{ deliveryTime.min }} - {{ deliveryTime.max }}</span> days
      </template>
      <template v-else>
        Unavailable
      </template>
    </div>
    <p
      class="h5-shipping-method-error"
      v-if="hasUndeliverableSelected"
    >
      <Icon name="icon-warning-outline" />
      Undeliverable Logistics
    </p>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { useAddressStore } from '@/pinia/address'
import { useAddress } from '../hooks/useAddress'
import { ShippingSelect } from '@/views/Carts/components/ShippingSelect'
import { useOrder } from '@/views/Carts/hooks/useOrder'
import { useShipStore } from '@/pinia/ship'

const addressStore = useAddressStore()
const { showAddressDialog } = useAddress()
const ship = useShipStore()

const countryUrl = computed(() => addressStore.cacheAddress ? addressStore.cacheAddress.searchImg : ship.country.countryUrl)

const { deliveryTime, hasUndeliverableSelected } = useOrder()
</script>

<style lang="less" scoped>
.h5-shipping-method {
  &__title {
    font-family: mon-700;
    font-size: 16px;
    line-height: 24px;
  }

  &__subTitle {
    margin-top: 6px;
    display: flex;
    align-items: center;
    font-family: mon-500;
    font-size: 11px;
    line-height: 14px;
  }

  &__logo {
    margin-left: 2px;
    width: 74px;
    height: 16px;
    color: #1153D6;
  }

  &__select {
    margin-top: 12px;
  }

  &__location {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__country {
    width: 16px;
  }

  &__address {
    font-family: mon-700;
    font-size: 12px;
    line-height: 16px;
  }

  &__change {
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    text-decoration: underline;
  }

  &__add {
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    text-decoration: underline;
    color: #007EB3;
  }

  &__delivery {
    margin-top: 6px;
    font-family: mon-500;
    font-size: 11px;
    line-height: 14px;

    > span {
      font-family: mon-700;
      color: #168A73;
    }
  }

  &-error {
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 2px;
    font-family: mon-600;
    font-size: 11px;
    line-height: 14px;
    color: #7A0505;

    &__icon {
      font-size: 14px;
    }
  }
}
</style>
